import React from "react";
import { useTheme } from "../contexts/ThemeContext";
import BottomNav from "./BottomNav";
import QuickExitFAB from "./QuickExitFAB";

export default function AppShell({ children, hideNav = false, hideExit = false }) {
  const { theme } = useTheme();
  return (
    <div className={`min-h-[100dvh] w-full ${theme === "night" ? "ss-night-bg" : "ss-soft-bg"}`}>
      <div className="relative mx-auto w-full max-w-md min-h-[100dvh] pb-28">
        {!hideExit && <QuickExitFAB />}
        {children}
        {!hideNav && <BottomNav />}
      </div>
    </div>
  );
}
